<template>
  <a href="/cart"
     title="Перейти в корзину"
     data-goal-yandex-click="click_go_cart"
     class="menu-icon-item menu-icon-item_cart"
     :class="this.isActive() ? '_active' : ''"
  >
    <span class="menu-icon-item__wrap">
        <span class="menu-icon-item__icon-wrap">
          <span class="menu-icon-item__icon">
            <CartIcon/>
            <span class="menu-icon-item__count">
              {{ count }}
            </span>
          </span>
        </span>
      <span class="menu-icon-item__title">
        Корзина
      </span>
    </span>
  </a>
</template>

<script>
import CartIcon from "../icons/CartIcon";
import { mapState, mapActions, mapGetters, mapMutations } from "vuex";

export default {
  name: "TheCartWidget",
  components: {
    CartIcon
  },
  methods: {
    ...mapActions({
      'loadCheckout': 'cart/loadCheckout'
    }),
    isActive() {
      return window.location.pathname === '/cart';
    }
  },
  computed: {
    ...mapGetters('cart', {
      'total': 'total',
      'count': 'count'
    })
  },
  mounted() {
    this.loadCheckout();
  }
}
</script>